import ReactDOM from "react-dom";
import { ButtonStyle } from "../../js/enums";
import Button from "./Button";
import Modal from "./Modal";

function ConfirmationModal({
  cancelText = "Cancel",
  children,
  confirmText = "Confirm",
  isSubmitting,
  modalTitle,
  onClose,
  onConfirm,
}) {
  const modalRoot = document.getElementById("modal-root");

  return !modalRoot ? (
    <></>
  ) : (
    <>
      {ReactDOM.createPortal(
        <Modal title={modalTitle} modalCloseButtonClick={onClose}>
          <div className="modal-body">{children}</div>
          <div className="modal-footer">
            <div className="w-100 d-flex justify-content-between">
              <Button
                onClick={onClose}
                style={ButtonStyle.Info}
                text={cancelText}
              />
              <Button
                disabled={isSubmitting}
                onClick={onConfirm}
                showSpinner={isSubmitting}
                style={ButtonStyle.Primary}
                text={confirmText}
              />
            </div>
          </div>
        </Modal>,
        modalRoot
      )}
    </>
  );
}

export default ConfirmationModal;
